import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./AdmissionTablePage.css";

const TABLE_PAGE_LIMIT = 29;

function AdmissionTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localAdmissions, setLocalAdmissions] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadAdmissions = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("admissions", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  useEffect(() => {
    if (offset === 0) {
      setLocalAdmissions(threeTable.admissions || []);
      setHasMore((threeTable.admissions || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.admissions || []).length);
    }
  }, [threeTable.admissions, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.admissions || []).length > 0) {
      setLocalAdmissions(threeTable.admissions);
      setHasMore(threeTable.admissions.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.admissions.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadAdmissions(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadAdmissions(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadAdmissions]);

  const admissions = localAdmissions;

  return (
    <div className="admission-table-container">
      <h2>Admission Table</h2>
      <div
        className="admission-table-wrapper"
        ref={tableWrapperRef}
        style={{ overflowY: "auto", maxHeight: "1400px" }}
      >
        <table className="admission-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {admissions.map((item, i) => (
              <tr key={i}>
                <td>{item.title}</td>
                <td>
                  {item.admissionLink ? (
                    <a href={item.admissionLink} target="_blank" rel="noopener noreferrer">View Admission</a>
                  ) : (
                    <Link to={`/mform/${item.jobSlug || item.slug}`}>View Admission</Link>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && admissions.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading admissions...
        </p>
      )}
      {isUpdating && admissions.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more admissions...
        </p>
      )}
      {!isUpdating && !hasMore && admissions.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more admissions.
        </p>
      )}
    </div>
  );
}

export default AdmissionTablePage;
